import { render, staticRenderFns } from "./NameEdit.vue?vue&type=template&id=c4ca5b08"
import script from "./NameEdit.vue?vue&type=script&lang=js"
export * from "./NameEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports